import { hbs } from 'ember-cli-htmlbars';
import { workflowComponent } from '@banking/ui/services/unit-balance';
import { ActionCreator } from '@banking/ui/workflows/balance';

// For the template

const template = hbs`
  <Banking::Market::Modal::Partial
    banking-applet-engine-styles
    data-test-create-printable-check-modal
    data-market-features="typography"
    @active={{this.printableCheckModalActive}}
    @onActiveChange={{this.onPrintableCheckModalActiveChange}}
    class={{if this.showWriteACheck "balance-do-more-card__write-a-check-modal market-modal-partial" "market-modal-partial"}}
  >
    {{#unless this.showWriteACheck}}
      <market-header close-button-aria-label="close" show-navigation compact>
      </market-header>
    {{/unless}}
    <Banking::PrintableCheck::CreateCheck
      @checkAmount={{this.checkAmount}}
      @checkIssuedConfiguration={{this.checkIssuedConfiguration}}
      @checkMemo={{this.checkMemo}}
      @checkPayeeName={{this.checkPayeeName}}
      @educationConfiguration={{this.educationConfiguration}}
      @isLoadingCreateCheck={{this.isLoadingCreateCheck}}
      @isLoadingDownloadCheck={{this.isLoadingDownloadCheck}}
      @isLoadingPrintCheck={{this.isLoadingPrintCheck}}
      @onActiveChange={{this.onPrintableCheckModalActiveChange}}
      @onContinueToWriteACheck={{this.onContinueToWriteACheck}}
      @onCreateCheck={{this.onCreateCheck}}
      @onDownloadCheck={{this.onDownloadCheck}}
      @onHideEducation={{this.onHideEducation}}
      @onPrintCheck={{this.onPrintCheck}}
      @onShowEducation={{this.onShowEducation}}
      @printableCheckId={{this.printableCheckId}}
      @showCheckSuccess={{this.showCheckSuccess}}
      @showCheckEducation={{this.showCheckEduation}}
      @showCheckError={{this.showCheckError}}
      @showWriteACheck={{this.showWriteACheck}}
      @unrecoverableError={{this.createPrintableCheckUnrecoverableError}}
      @updateCreatePrintableCheckRequest={{this.updateCreatePrintableCheckRequest}}
      @writeCheckConfiguration={{this.writeCheckConfiguration}}
      @writeCheckInputHints={{this.writeCheckInputHints}}
    />
  </Banking::Market::Modal::Partial>
`;
const mapStateToProps = state => ({
  checkAmount: state.checkAmount,
  checkIssuedConfiguration: state.checkIssuedConfiguration,
  checkMemo: state.checkMemo,
  checkPayeeName: state.checkPayeeName,
  createPrintableCheckUnrecoverableError: state.createPrintableCheckUnrecoverableError,
  educationConfiguration: state.educationConfiguration,
  isLoadingCreateCheck: state.isLoadingCreateCheck,
  isLoadingDownloadCheck: state.isLoadingDownloadCheck,
  isLoadingPrintCheck: state.isLoadingPrintCheck,
  printableCheckId: state.printableCheckId,
  printableCheckModalActive: state.printableCheckModalActive,
  showCheckSuccess: state.showCheckSuccess,
  showCheckEducation: state.showCheckEducation,
  showCheckError: state.showCheckError,
  showWriteACheck: state.showWriteACheck,
  writeCheckConfiguration: state.writeCheckConfiguration,
  writeCheckInputHints: state.writeCheckInputHints
});
const mapActionsToProps = () => ({
  onContinueToWriteACheck: ActionCreator.userClickContinueToWriteACheck,
  onCreateCheck: ActionCreator.userClickCreatePrintableCheck,
  onDownloadCheck: ActionCreator.userClickDownloadCheck,
  onHideEducation: ActionCreator.userClickHideEducation,
  onPrintableCheckModalActiveChange: active => active ? null : ActionCreator.userClickDismissPrintableCheckModal(),
  onPrintCheck: ActionCreator.userClickPrintCheck,
  onShowEducation: ActionCreator.userClickShowEducation,
  updateCreatePrintableCheckRequest: ActionCreator.userUpdateCreatePrintableCheckRequest
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);